import { buildClassName, lookupPreset } from "./util";

// id: "5f691ac0-bb71-4678-93d3-3940f0d6d089"
// title: ""
// type: :gf_preset
// key: "groupflow"
// parent_id: "45737034-fc65-4e6f-85ae-5fbe0426ba62"
export function Groupflow5f691ac0Bb71467893d33940f0d6d089(props: any) {
  const GroupFlowTag = lookupPreset("GroupFlowTag");
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <GroupFlowTag className="Groupflow5f691ac0Bb71467893d33940f0d6d089" parentTag={buildClassName("Groupflow5f691ac0Bb71467893d33940f0d6d089", parentTag)} {...props} />
  );
}

// id: "b4b43565-1720-4ab1-84ee-f09d4359f052"
// title: ""
// type: :text
// key: "navMenuSlug"
// parent_id: "4953b8dc-0339-4dcd-9289-19a22201f90a"
export const NavMenuSlugB4b4356517204ab184eeF09d4359f052 = "footer-nav";

// id: "4ba94186-9f35-4481-949d-b9cf2982ae45"
// title: ""
// type: :gf_preset
// key: "logo"
// parent_id: "45737034-fc65-4e6f-85ae-5fbe0426ba62"
export function Logo4ba941869f354481949dB9cf2982ae45(props: any) {
  const Logo = lookupPreset("Logo");
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Logo className="Logo4ba941869f354481949dB9cf2982ae45" parentTag={buildClassName("Logo4ba941869f354481949dB9cf2982ae45", parentTag)} contentSlug="footer-logo" logoType="FOOTER" {...props} />
  );
}

// id: "4953b8dc-0339-4dcd-9289-19a22201f90a"
// title: ""
// type: :gf_preset
// key: "links"
// parent_id: "45737034-fc65-4e6f-85ae-5fbe0426ba62"
export function Links4953b8dc03394dcd928919a22201f90a(props: any) {
  const Navigation = lookupPreset("Navigation");
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Navigation className="Links4953b8dc03394dcd928919a22201f90a" parentTag={buildClassName("Links4953b8dc03394dcd928919a22201f90a", parentTag)} navMenuSlug="footer-nav" {...props} />
  );
}

// id: "7b2b6be3-cfd7-455a-9d93-3d0c5627692f"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "4ba94186-9f35-4481-949d-b9cf2982ae45"
export const ContentSlug7b2b6be3Cfd7455a9d933d0c5627692f = "footer-logo";

// id: "01a98e7a-e723-4ab5-af4c-f23d4bf1976c"
// title: ""
// type: :gf_preset
// key: "copyright"
// parent_id: "45737034-fc65-4e6f-85ae-5fbe0426ba62"
export function Copyright01a98e7aE7234ab5Af4cF23d4bf1976c(props: any) {
  const GroupCopyright = lookupPreset("GroupCopyright");
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <GroupCopyright className="Copyright01a98e7aE7234ab5Af4cF23d4bf1976c" parentTag={buildClassName("Copyright01a98e7aE7234ab5Af4cF23d4bf1976c", parentTag)} {...props} />
  );
}

// id: "800567ee-4ce5-4e54-8f63-886c9b5da46e"
// title: ""
// type: :text
// key: "logoType"
// parent_id: "4ba94186-9f35-4481-949d-b9cf2982ae45"
export const LogoType800567ee4ce54e548f63886c9b5da46e = "FOOTER";

// id: "45737034-fc65-4e6f-85ae-5fbe0426ba62"
// title: "Footer"
// type: :html
// key: "default-footer"
// parent_id: nil
export function DefaultFooter45737034Fc654e6f85ae5fbe0426ba62(props: any) {
  const Navigation = lookupPreset("Navigation");
  const Logo = lookupPreset("Logo");
  const GroupCopyright = lookupPreset("GroupCopyright");
  const GroupFlowTag = lookupPreset("GroupFlowTag");
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <footer className={`${parentTag || ""} DefaultFooter45737034Fc654e6f85ae5fbe0426ba62 footer`}>
      {props["links"] || <Navigation className="Links4953b8dc03394dcd928919a22201f90a" parentTag={buildClassName("Links4953b8dc03394dcd928919a22201f90a", parentTag)} navMenuSlug="footer-nav" {...props} />}
      <div className="logo-wrapper">
        {props["logo"] || <Logo className="Logo4ba941869f354481949dB9cf2982ae45" parentTag={buildClassName("Logo4ba941869f354481949dB9cf2982ae45", parentTag)} contentSlug="footer-logo" logoType="FOOTER" {...props} />}
      </div>
      {props["copyright"] || <GroupCopyright className="Copyright01a98e7aE7234ab5Af4cF23d4bf1976c" parentTag={buildClassName("Copyright01a98e7aE7234ab5Af4cF23d4bf1976c", parentTag)} {...props} />}
      {props["groupflow"] || <GroupFlowTag className="Groupflow5f691ac0Bb71467893d33940f0d6d089" parentTag={buildClassName("Groupflow5f691ac0Bb71467893d33940f0d6d089", parentTag)} {...props} />}
    </footer>
  );
}

const Components = {
  Groupflow5f691ac0Bb71467893d33940f0d6d089,
  NavMenuSlugB4b4356517204ab184eeF09d4359f052,
  Logo4ba941869f354481949dB9cf2982ae45,
  Links4953b8dc03394dcd928919a22201f90a,
  ContentSlug7b2b6be3Cfd7455a9d933d0c5627692f,
  Copyright01a98e7aE7234ab5Af4cF23d4bf1976c,
  LogoType800567ee4ce54e548f63886c9b5da46e,
  DefaultFooter45737034Fc654e6f85ae5fbe0426ba62
}

export default Components;